<mat-expansion-panel
  #panel
  (expandedChange)="setActive($event)"
  [expanded]="filter?.isActive"
  [hideToggle]="true"
  class="mat-elevation-z0 light-bg"
  >
  <mat-expansion-panel-header
    (click)="cb.checked = panel.expanded"
    collapsedHeight="36px"
    expandedHeight="36px"
    >
    <mat-checkbox
      #cb
      (change)="panel.toggle()"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      [checked]="filter?.isActive ?? false"
      color="primary"
      disableRipple
      >
      {{ filter?.name ?? '' | translate }}
    </mat-checkbox>
  </mat-expansion-panel-header>
  <form [formGroup]="frmGroup">
    <ng-container [formArrayName]="frmArrayName">
      @if (filter?.type !== 'list' && filter?.type !== 'daterange') {
        <mat-form-field appearance="outline" class="m-t-1 slim clear-infix no-hint">
          <mat-select (selectionChange)="updateOption($event.value)" [value]="activeOptions[0]">
            @for (opt of filter?.options; track opt) {
              <mat-option
                (click)="$event.stopPropagation()"
                [value]="opt"
                >
                {{ opt.filterOption }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (filter?.type === 'number') {
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="mirror-y" color="primary">shortcut</mat-icon>
            <mat-form-field appearance="outline" class="slim clear-infix no-hint" fxFlex="96px">
              <input [formControlName]="frmControlName" autocomplete="off" matInput type="number" />
            </mat-form-field>
          </div>
        }
        @if (filter?.type === 'date') {
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="mirror-y" color="primary">shortcut</mat-icon>
            <mat-form-field
              (click)="$event.stopPropagation()"
              appearance="outline"
              class="slim clear-infix no-hint"
              fxFlex="grow"
              >
              <input [formControlName]="frmControlName" [matDatepicker]="datePicker" matInput />
              <mat-datepicker-toggle [for]="datePicker" matSuffix />
              <mat-datepicker #datePicker startView="multi-year" />
            </mat-form-field>
          </div>
        }
        @if (filter?.type === 'daterange') {
          <ng-template fxLayout="column">
            <div class="width-match-parent" fxLayout="column">
              <mat-form-field
                (click)="$event.stopPropagation()"
                appearance="outline"
                class="slim clear-infix no-hint width-match-parent"
                fxFlex="grow"
                >
                <input [formControlName]="frmControlName" [matDatepicker]="datePicker1" matInput />
                <mat-datepicker-toggle [for]="datePicker1" matSuffix />
                <mat-datepicker #datePicker1 startView="multi-year" />
              </mat-form-field>
            </div>
          </ng-template>
        }
        @if (filter?.type === 'string') {
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="mirror-y" color="primary">shortcut</mat-icon>
            <mat-form-field
              appearance="outline"
              class="slim clear-infix no-hint"
              fxFlex="grow"
              style="width: 0"
              >
              <input
                [formControlName]="frmControlName ?? ''"
                autocomplete="off"
                matInput
                type="text"
                />
            </mat-form-field>
          </div>
        }
      } @else {
        @if (filter?.type === 'list') {
          <div
            [formArrayName]="frmControlName ?? ''"
            class="m-t-1"
            fxLayout="column"
            fxLayoutGap="4px"
            >
            @for (opt of filter?.options; track opt; let i = $index) {
              <mat-checkbox
                (change)="opt.isActive = $event.checked"
                [formControlName]="i"
                >
                {{ opt.filterOption | translate }}
              </mat-checkbox>
            }
          </div>
        } @else {
          <div
            [formArrayName]="frmControlName ?? ''"
            class="m-t-1"
            fxLayout="column"
            fxLayoutGap="4px"
            >
            @for (opt of filter?.options; track opt; let i = $index) {
              <mat-form-field
                (click)="$event.stopPropagation()"
                appearance="outline"
                class="slim clear-infix no-hint width-match-parent"
                fxFlex="grow"
                >
                <input [formControlName]="i" [matDatepicker]="datePicker" matInput />
                <mat-datepicker-toggle [for]="datePicker" matSuffix />
                <mat-datepicker #datePicker startView="multi-year" />
              </mat-form-field>
            }
          </div>
        }
      }

    </ng-container>
  </form>
</mat-expansion-panel>
